import {
    Box, Button, IconButton, TextField, Tooltip, Typography, Modal, Divider,
    Dialog,
    Autocomplete,
    Grow,
} from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';
import { newAmountCard } from '../../../../Components/CommonCards/CommonCards';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import Loader from '../../../../Components/Loader';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { CommonPatientDetails, renderInsCorpDetails } from '../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../Styles/Colors';
import Billling from './Billling';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import './commonBilling.css'
import { DataGrid } from '@mui/x-data-grid';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { convertDateTime, formatDate, GetInvestigationName } from '../../../../Components/CommonFunctions/CommonFunctions';
import { clearCachevalue, getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';

const HospitalBilling = (props) => {
    const [cardState, setCardState] = useState({
        totalPatients: 0,
        totalBills: 0,
        totalBillingAmount: 0,
        totalCreditAmount: 0,
        totalReceiptAmount: 0,
        totalUpiAmount: 0,
        totalCashAmount: 0,
        totalCardAmount: 0,
        totalRefundAmount: 0,
        totalCancelAmount: 0,
        openReceipt: false,
        totalBanKAmount: 0,
        totalChequeAmount: 0
    });
    const [openPopup, setOpenPopup] = useState(null)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [payment, setPayment] = useState({
        isCash: false,
        isCard: false,
        isUPI: false,
        isBankTranfer: false,
        isCheque: false,
        openCashBalancebox: false,
        isCredit: true,
        totalPayableAmount: 0,
        CashAmount: "",
        CashBalanceAmount: "",
        ReceivedCashAmount: "",
        CardAmount: "",
        CardTransactionNumber: "",
        UPIAmount: "",
        UPINumber: "",
        BankTfrAmount: "",
        BankTfrNumber: "",
        ChequeAmount: "",
        ChequeNumber: "",
    });

    const [UhidOrPhNumber, setUhidOrPhNumber] = useState('');
    const [IPorIPNumber, setIPorIPNumber] = useState('');
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [isErrorMsgText, setIsErrorMsgText] = useState('');
    const [successMsg, setSuccessMsg] = useState(false);
    const [successMsgText, setSuccessMsgText] = useState('');
    const [isLoader, setIsLoader] = useState(false);
    const [PatientDetails, setPatientDetails] = useState({});
    const [PatientSearchList, setPatientSearchList] = useState([]);
    const [triggerSignal, setTriggerSignal] = useState(false);
    const [historyData, setHistoryData] = useState({})
    const [pendingDraft, setpendingDraft] = useState([])
    const [pendingOrder, setPedingOrder] = useState([])
    const [multiPendingData, setMultiPendingData] = useState({})
    const [sendDraftData, setSendDraftData] = useState([])
    const [sendPendingOrder, setSendPendingOrder] = useState(null)
    const [selectedAppointment, setSelectedAppointment] = useState(null)
    const [appointmentList, setAppointmentList] = useState([])
    const [orderId, setOrderId] = useState(null)
    const [sendBillingList, setSendBillingList] = useState([])
    const [hasDraftOrder, setHasDraftOrder] = useState(null)
    const [sendPendingList, setSendPendingList] = useState(null)
    const [insuToolOpen, setInsuToolOpen] = useState(false);   
    
    let history = useHistory()
    let userData = JSON.parse(localGetItem('loggedInUserInfo'))
    const STYLES = {
        FONT_SIZE_LOW_2: "0.9rem",
        FONT_SIZE_LOW_3: "0.8rem",
        FONT_WEIGHT: "bold"
    };


    const errorMessage = (message) => {
        setIsErrorMsgText(message);
        setIsErrorMsg(true);
    };

    const successMessage = (message) => {
        setSuccessMsgText(message);
        setSuccessMsg(true);
    };

    const LoaderFunction = (key) => {
        setIsLoader(key);
    };

    useEffect(() => {
        getCollectionDetails()
    }, [])

    useEffect(() => {
        // Hide tooltip after 2 seconds
        const hideTooltip = setTimeout(() => {
            setInsuToolOpen(undefined);
        }, 2000);

        return () => {
            clearTimeout(hideTooltip);
        };
    }, [PatientDetails?.patient_id])

    useEffect(() => {
        // FROM OP LIST DATA
        if (history?.location?.state?.fromOpList) {
            let opListData = history?.location?.state?.opListData
            let appointment_id = opListData?.appointment_id ? opListData?.appointment_id : ''
            setHasDraftOrder('both')
            if (Object.keys(opListData)?.length > 0) {
                appointment_id ? getPatientDetails(appointment_id, true) : getPatientDetails(opListData?.patient_id)
                getPendingOrderList(opListData?.patient_id, '', opListData?.appointment_id)
            }
        }
        // FROM DRAFT DATA
        if (history?.location?.state?.fromDraft) {
            let draftData = history?.location?.state?.draftData
            let appointment_id = draftData?.appointment_id ? draftData?.appointment_id : ''
            if (Object.keys(draftData)?.length > 0) {
                setHasDraftOrder('draft')
                appointment_id ? getPatientDetails(appointment_id, true) : getPatientDetails(draftData?.patient_id)
                getPendingOrderList(draftData?.patient_id, '', draftData?.patientData?.appointment_id)
                getPatientPendingDraftList(null, draftData?.id, draftData?.patientData?.appointment_id)
                setSelectedAppointment(null)
            }
        }
        // FROM ORDER DATA
        if (history?.location?.state?.fromOrder) {
            let orderData = history?.location?.state?.orderData
            let appointment_id = orderData?.appointment_id ? orderData?.appointment_id : ''
            setHasDraftOrder('order')
            appointment_id ? getPatientDetails(appointment_id, true) : getPatientDetails(orderData?.patient_id)
            // setSendPendingOrder(orderData)
            getPendingOrderList(orderData?.patient_id, orderData?.order_id, orderData?.appointment_id)
            getPendingOrderWithOrderId(orderData?.patient_id, orderData?.order_id, orderData?.appointment_id)
            setSelectedAppointment(null)
        }
        // FROM CREATE ORDER
        if (history?.location?.state?.patientId) {
            let appointment_id = history?.location?.state?.appointment_id ? history?.location?.state?.appointment_id : ''
            let patientDetails = history?.location?.state?.patientId
            setHasDraftOrder('both')
            getPatientDetails(appointment_id, true)
            getPendingOrderList(patientDetails?.patient_id, '', appointment_id)
            setSelectedAppointment(null)
        }
        // FROM MODIFY AND CANCEL BILL
        if (history?.location?.state?.fromPatientBills) {
            let patientDetails = history?.location?.state?.patientDetails
            let invoiceId = history?.location?.state?.invoiceId
            let appointment_id = history?.location?.state?.appointment_id ? history?.location?.state?.appointment_id : ''
            appointment_id ? getPatientDetails(appointment_id, true, invoiceId) : getPatientDetails(patientDetails?.patient_id, false, invoiceId)
            getPatientPendingDraftList(patientDetails?.patient_id, '', patientDetails?.appointment_id)
            getPendingOrderList(patientDetails?.patient_id, '', patientDetails?.appointment_id)
            // getIndividualBillDetails(invoiceId) api call set after patient detail
            setSelectedAppointment(null)
        }
        // FROM SAVED BILL
        if (history?.location?.state?.fromPatientSavedBill) {
            let patientDetails = history?.location?.state?.patientDetails
            let invoiceId = history?.location?.state?.invoiceId
            let fromInvoiceSearch = history?.location?.state?.invoiceSearchId
            let invoiceData = invoiceId ? invoiceId : fromInvoiceSearch
            let FromLabKey = fromInvoiceSearch ? true : false
            let appointment_id = history?.location?.state?.appointment_id ? history?.location?.state?.appointment_id : ''
            appointment_id ? getPatientDetails(appointment_id, true, invoiceData, FromLabKey) : getPatientDetails(patientDetails?.patient_id, false, invoiceData, FromLabKey)
            getPatientPendingDraftList(patientDetails?.patient_id, '', patientDetails?.appointment_id)
            getPendingOrderList(patientDetails?.patient_id, '', patientDetails?.appointment_id)
            // api call set after patient detail
            // if (history?.location?.state?.invoiceSearchId) {
            //     getIndividualBillDetails(history?.location?.state?.invoiceSearchId, true)
            // } else {
            //     getIndividualBillDetails(invoiceId)
            // }
            setSelectedAppointment(null)
        }
        // FROM PENDING LIST
        if (history?.location?.state?.fromPendingList) {
            let patientDetails = history?.location?.state?.patientDetails
            let invoiceId = history?.location?.state?.invoiceId
            let appointment_id = history?.location?.state?.appointment_id ? history?.location?.state?.appointment_id : ''
            appointment_id ? getPatientDetails(appointment_id, true, invoiceId) : getPatientDetails(patientDetails?.patient_id, false, invoiceId)
        }
        // FROM BILL CONVERT
        if (history?.location?.state?.fromBillConvert) {
            let patientDetails = history?.location?.state?.patientDetails
            let invoiceId = history?.location?.state?.invoiceId
            let appointment_id = history?.location?.state?.appointment_id ? history?.location?.state?.appointment_id : ''
            appointment_id ? getPatientDetails(appointment_id, true, invoiceId) : getPatientDetails(patientDetails?.patient_id, false, invoiceId)
        }
        // FROM APPROVER LIST
        if(history?.location?.state?.fromApprover){
            let patientDetails = history?.location?.state?.patientDetails
            let invoiceId = history?.location?.state?.invoiceId
            let appointment_id = history?.location?.state?.appointment_id ? history?.location?.state?.appointment_id : ''
            appointment_id ? getPatientDetails(appointment_id, true, invoiceId) : getPatientDetails(patientDetails?.patient_id, false, invoiceId)
        }
    }, [
        history?.location?.state?.fromOpList, history?.location?.state?.fromDraft,
        history?.location?.state?.fromOrder, history?.location?.state?.patientId,
        history?.location?.state?.fromPatientBills, history?.location?.state?.fromBill,
        history?.location?.state?.fromPatientSavedBill,
        history?.location?.state?.fromBillConvert, history?.location?.state?.fromApprover
    ])
    const getIndividualBillDetails = (id, FromLabKey = false, fromChange = false, opNumber) => {
        try {
            let params = ''
            if (fromChange) {
                params = '?op_number=' + opNumber
            } else {
                let billId = id ? id : null
                params = FromLabKey ? ('?lab_order_line_id=' + billId) : ('?bill_id=' + billId)
            }
            RestAPIService.getAll(Serviceurls.NEW_BILLING_INDIVIDUAL_BILL_GET + params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setSendBillingList(response?.data?.data)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPatientDataSearch = (patient_data = "") => {
        try {
            LoaderFunction(true);
            RestAPIService.getAll(Serviceurls.NEW_BILLING_PATIENT_SEARCH + '?search_key=' + patient_data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const list = response.data.data || [];
                        LoaderFunction(false);
                        if (list?.length) {
                            let data = list?.length === 1 ? list[0] : {}
                            setIPorIPNumber("");
                            setUhidOrPhNumber("");
                            setTriggerSignal(!triggerSignal);
                            if (list?.length === 1) {
                                getPatientDetails(data?.patient_id)
                                getPendingOrderList(data?.patient_id)
                            }
                            if (list?.length > 1) {
                                setPatientSearchList(list);
                            }
                        } else {
                            errorMessage("No Records Found !");
                        }
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const getPatientPendingDraftList = (patient_id, pendingData, appointment_id = '') => {
        try {
            let params = ''
            let type = userData?.module_name === 'Laboratory' ? 'LAB' : userData?.module_name === 'Radiology' ? 'RADIOLOGY' : userData?.module_name === 'Investigation' ? GetInvestigationName() : userData?.module_name === 'Doctor' ? 'DOCTOR' : ''
            if (patient_id) {
                params = '?patient_id=' + patient_id + '&module_type=' + type + '&appointment_id=' + (appointment_id || '')
            } else {
                params = '?bill_id=' + pendingData + '&module_type=' + type
            }
            RestAPIService.getAll(Serviceurls.NEW_BILLING_SAVED_BILL_GET + params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        if (patient_id) {
                            setpendingDraft(response?.data?.data)
                        } else {
                            let draftData = response?.data?.data?.length > 0 ? response?.data?.data : []
                            setSendDraftData(draftData)
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPendingOrderList = (patientId, orderId = '', appointment_id = '') => {
        try {
            let type = userData?.module_name === 'Laboratory' ? 'LAB' : userData?.module_name === 'Radiology' ? 'RADIOLOGY' : userData?.module_name === 'Investigation' ? userData?.investigation_type_name : ''
            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_ORDER_LIST + '?patient_id=' + patientId + '&omit_order_id=' + orderId + '&module_type=' + type + '&appointment_id=' + (appointment_id || "") + '&for_billing=true')
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let orderData = response?.data?.data?.length > 0 ? response?.data?.data : []
                        setPedingOrder(orderData)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPendingOrderWithOrderId = (patientId, orderId = '', appointment_id = '') => {
        try {
            let type = userData?.module_name === 'Laboratory' ? 'LAB' : userData?.module_name === 'Radiology' ? 'RADIOLOGY' : userData?.module_name === 'Investigation' ? userData?.investigation_type_name : ''
            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_ORDER_LIST + '?patient_id=' + patientId + '&order_id=' + orderId + '&module_type=' + type + '&appointment_id=' + (appointment_id || "") + '&for_billing=true')
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let orderData = response?.data?.data?.length > 0 ? response?.data?.data[0] : []
                        setSendPendingOrder(orderData)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getPatientDetails = (patient_id, fromAppointment = false, invoiceId, FromLabKey = false) => {
        try {
            let params = ''
            if (fromAppointment) {
                params = Serviceurls.FO_PATIENT_APPOINTMENT_DETAILS + '?appointment_id=' + patient_id
            } else {
                params = Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + patient_id
            }
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let data = response?.data?.data
                        setPatientDetails(data)
                        setInsuToolOpen(true);
                        let module = data?.appointment_id ? 'op' : 'op'
                        let opNumber = data?.op_number ? data?.op_number : ''
                        fromAppointment ? getPatientNumberList(data?.patient_id, module, opNumber) : getPatientNumberList(patient_id, module, opNumber)
                        if (data?.patient_id) {
                            getPatientPendingDraftList(data?.patient_id, '', data?.appointment_id)
                        }
                        if (FromLabKey) {
                            getIndividualBillDetails(invoiceId, true)
                        } else if (invoiceId) {
                            getIndividualBillDetails(invoiceId)
                        }
                        if(userData?.module_name === 'front_office'){
                            getLastVisitDateOutstandingAmount(data)
                        }
                    }
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const triggerPatientData = (flag) => {
        if(flag){
            getPatientDetails(PatientDetails?.patient_id, false, null)
        }
    }


        const getLastVisitDateOutstandingAmount = (Datas) => {
            try {
                let APIURL = ""
                if (Datas) {
                    APIURL = "?patient_id=" + Datas?.patient_id + "&module=" + "OP" + "&branch_id=" + localGetItem("BranchId") + "&appointment_id=" + (Datas?.appointment_id || "")
                } else {
                    APIURL = "?patient_id=" + Datas?.patient_id + "&module=" + "OP" + "&branch_id=" + localGetItem("BranchId")
                }
                RestAPIService.getAll(Serviceurls.FO_PATIENT_LAST_VISIT_DATE_AND_BALANCE_AMOUNT + APIURL)
                    .then((response) => {
                        if (response.data.status === "success") {
                            let Date = response.data?.last_visited_date ? response.data.last_visited_date : ""
                            let Amount = response.data?.total_outstanding ? response.data.total_outstanding : 0
                            let AdvanceBalance = response.data?.advance_balance ? response.data.advance_balance : 0
                            let Obj = { "last_visited_date": Date, "total_outstanding": Amount, advance_balance: AdvanceBalance }
                            props.VisitDateBalAmount(Obj)
                        }
                        else {
                            errorMessage(response.data.message)
                        }
                    }).catch((error) => {
                        errorMessage(error.message)
                    })
            } catch (e) {
                errorMessage(e.message)
            }
        }

    const getPatientNumberList = (patientId = '', module = 'op', opNumber = '') => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_BILLING_PATIENT_OP_IP_NUM_LIST + '?patient_id=' + patientId + '&module=' + module + '&from_billing=' + true)
                .then((response) => {
                    if (response.data?.status === 'success') {
                        const list = response.data.data || [];
                        if (list?.length) {
                            let data = list?.length === 1 ? list[0] : null
                            let fetch = list?.find(item => item?.op_number === opNumber)
                            setSelectedAppointment(fetch)
                            setAppointmentList(response?.data?.data)
                        }
                    }
                }).catch((error) => {
                    LoaderFunction(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getCollectionDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_COLLECTION_CARD)
                .then((response) => {
                    if (response.data.status === 'success') {
                        let CardDetails = response?.data?.data || null
                        setCardState((prev) => ({
                            ...prev,
                            totalPatients: CardDetails?.total_patient || 0,
                            totalBills: CardDetails?.total_bills || 0,
                            totalBillingAmount: CardDetails?.total_bill_amount || 0,
                            totalCreditAmount: CardDetails?.total_credit_amount || 0,
                            totalCancelAmount: CardDetails?.total_cancel_bills || 0,
                            totalRefundAmount: CardDetails?.total_refund_amount || 0,
                            totalReceiptAmount: CardDetails?.total_receipt_amount || 0,
                            totalCashAmount: CardDetails?.cash_amount || 0,
                            totalCardAmount: CardDetails?.card_amount || 0,
                            totalUpiAmount: CardDetails?.upi_amount || 0,
                            totalBanKAmount: CardDetails?.bank_amount || 0,
                            totalChequeAmount: CardDetails?.cheque_amount || 0,
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };


    const renderPatientCard = (item, type) => {
        try {
            let gender = item?.gender === 'm' ? 'M' : item?.gender === 'f' ? 'F' : 'T'
            let patientName = `${item?.patient_name || item?.first_name} ${item?.patient_age_str || item?.patient_age}/${gender}`
            let uhidMob = `${item.patient_account_number || item?.patient_account_numbers} | ${item?.mobile_number || item?.patient_mobile_number || item?.patients_mobile}`
            let profile = (item?.photo_url || item?.patient_photo_url || item?.patient__photo_url) ? (item?.photo_url || item?.patient_photo_url || item?.patient__photo_url) : gender === 'M' ? ImagePaths.Male.default : ImagePaths.Female.default
            let borderColor = (item?.patient_type === 'New Patient' || item?.patient_type === 'new_patient') ? '#F1584A' : (item?.patient_type === 'Review Patient' || item?.patient_type === 'review_patient') ? '#29B6F6' : '#800080'
            let consultantName = item?.doctor_name || '-'
            let opNumber = item?.op_number
            let appointmentNo = formatDate(item?.appointment_date)
            return (
                <Box component={'div'} sx={{ backgroundColor: "white", marginLeft: '0.5vw', padding: "0.5vw", boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    {type === 'consultant' ?
                        <Box component={'div'} sx={{ width: "13vw" }}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} >
                                <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box component={'img'} src={ImagePaths.Doctor_Icon.default} height={'5dvh'} width={'2.3dvw'} />
                                </Box>
                                <Box component={'div'}>
                                    <Typography fontSize={STYLES.FONT_SIZE_LOW_3} color={Colors.grayShade}>{'Consultant Name'}</Typography>
                                    {consultantName ? consultantName?.length > 18 ?
                                        <Tooltip placement='top' title={consultantName}><Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{consultantName?.slice(0, 18) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={600}>{consultantName}</Typography> : '-'}
                                </Box>
                            </Box>
                        </Box> :
                        <Box component={'div'} sx={{ width: "20vw", display: 'flex' }}>
                            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} mr={opNumber ? '2rem' : '0rem'}>
                                <Box component={'div'} mr={'0.5rem'} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box component={'img'} src={profile} height={'5dvh'} width={'2.3dvw'} borderRadius={'50%'} border={`2px solid ${borderColor}`} />
                                </Box>
                                <Box component={'div'}>
                                    {patientName ? patientName?.length > (opNumber ? 19 : 30) ?
                                        <Tooltip placement='top' title={patientName}><Typography noWrap fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName?.slice(0, (opNumber ? 17 : 28)) + '...'}{renderInsCorpDetails(item, insuToolOpen)}</Typography></Tooltip> :
                                        <Typography noWrap fontSize={STYLES.FONT_SIZE_LOW_2} fontWeight={STYLES.FONT_WEIGHT}>{patientName}{renderInsCorpDetails(item, insuToolOpen)}</Typography> : '-'}
                                    {uhidMob ? uhidMob?.length > (opNumber ? 20 : 30) ?
                                        <Tooltip placement='top' title={uhidMob}><Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob?.slice(0, (opNumber ? 18 : 28)) + '...'}</Typography></Tooltip> :
                                        <Typography fontSize={STYLES.FONT_SIZE_LOW_3}>{uhidMob}</Typography> : '-'}
                                </Box>
                            </Box>
                            {opNumber ?
                                <Box component={'div'}>
                                    <Box component={'div'}>
                                        {opNumber ? opNumber?.length > 10 ?
                                            <Tooltip title={opNumber} placement={'top'} arrow>
                                                <Typography id='eMed_Com_Patient_Name'>{opNumber ? opNumber?.length > 9 ? ('...' + opNumber.slice(10)) : opNumber : '-'}</Typography>
                                            </Tooltip> : <Typography>{opNumber}</Typography> : '-'}
                                        <Typography id='eMed_Com_Patient_UhidText'>{appointmentNo ? `| ${appointmentNo}` : '-'}</Typography>
                                    </Box>
                                </Box> : null}
                        </Box>}
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const PatientSelectionPopup = () => {
        return (
            <Modal open={PatientSearchList?.length > 0}>
                <Box className="eMed_MobileNum_Main" width={"31.5vw"}>
                    <Box component={'div'} className="eMed_MobileNum_Header">
                        <Typography variant='h6'>{"Patient List"}</Typography>
                        <IconButton onClick={() => setPatientSearchList([])} marginRight={'4vw'}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                        </IconButton>
                    </Box>
                    <Box component={'div'} className="eMed_MobileNum_wrapper" width={"31vw"}>
                        {PatientSearchList?.length > 0 && PatientSearchList.map((list) => {
                            let patientFullName = `${list.first_name} ${list.last_name}`;
                            const patientData = {
                                ...list,
                                patient_name: patientFullName,
                                patient_mobile_number: list.mobile_number,
                                patient_photo_url: list.photo_url
                            };

                            return (
                                <Box key={list.patient_account_number}>
                                    <Box className="eMed_Patient_Num_Search_pop" sx={{ width: "30vw" }}>
                                        <CommonPatientDetails data={patientData} hideInsurance = {true}/>
                                        <Button
                                            size='small'
                                            variant='contained'
                                            sx={{ textTransform: 'capitalize' }}
                                            onClick={() => {
                                                setPatientSearchList([]);
                                                // getPatientDataSearch(list.patient_account_number);
                                                getPatientDetails(list?.patient_id)
                                                getPendingOrderList(list?.patient_id, '', list?.appointment_id)
                                            }}
                                        >
                                            Create Bill
                                        </Button>
                                    </Box>
                                    <Divider />
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Modal>
        );
    };

    const handleTableCheckbox = (id) => {
        try {
            if (id?.length) {
                let selectedIDs = new Set(id);
                let selectedRows = pendingOrder?.filter((row) => selectedIDs.has(row.sno));
                let FinalData = {
                    order_line_items: [],
                    patient_id: null,
                    order_id : null
                }
                selectedRows?.forEach((element) => {
                    FinalData.order_line_items.push(...element?.order_line_items)
                    FinalData.patient_id = element.patient_id
                    FinalData.order_id = element.order_id
                })
                setMultiPendingData(FinalData)
                setSendPendingOrder(FinalData)
            } else {
                setSendPendingOrder({})
                setMultiPendingData({})
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const PrintCancelledData = (Billid) => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_OP_INVOICE_PRINT + `?invoce_id=${Billid}`).
                then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    errorMessage(error?.message)
                })
        } catch (e) {
            errorMessage(e?.message)
        }
    }

    const renderPendingDraftPopup = () => {
        try {
            pendingDraft?.forEach((element, index) => element.sno = index + 1)
            pendingOrder?.forEach((element, index) => element.sno = index + 1)
            const draft = [
                {
                    field: 'sno', headerName: 'S.No', flex: 0.1,
                    renderCell: (params) => {
                        return (<Box>{params?.row?.sno}</Box>)
                    }
                },
                {
                    field: 'draft_details', headerName: 'Draft Details', flex: 0.25,
                    renderCell: (params) => {
                        let tempInvoice = params?.row?.temp_invoice_number
                        return (
                            <Box>
                                {tempInvoice ? tempInvoice?.length > 15 ?
                                    <Tooltip placement='top' title={tempInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + tempInvoice?.slice(-15)}</Typography></Tooltip> :
                                    <Typography fontSize={'0.9rem'} fontWeight={600}>{tempInvoice}</Typography> : '-'}
                                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{params?.row?.invoice_date}</Typography>
                            </Box>
                        )
                    }
                },
                {
                    field: 'no_of_items', headerName: 'No of Orders', flex: 0.2,
                    renderCell: (params) => {
                        return (
                            <Box>{params?.row?.line_item_count}</Box>
                        )
                    }
                },
                {
                    field: 'doctor_details', headerName: 'Doctor Details', flex: 0.25,
                    renderCell: (params) => {
                        let doctorName = params?.row?.patient_data?.doctor_name
                        let doctorSpec = params?.row?.patient_data?.specialization_name
                        return (
                            <Box>
                                {doctorName ? doctorName?.length > 15 ?
                                    <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                                {doctorSpec ? doctorSpec?.length > 15 ?
                                    <Tooltip placement='top' title={doctorSpec}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'action', headerName: 'Action', flex: 0.2,
                    renderCell: (params) => {
                        return (
                            <Box>
                                <Button
                                    className='Common_Btn_Min_Width'
                                    onClick={() => {
                                        // setpendingDraft(prev => prev.filter((_, index) => (index + 1) !== params?.row?.sno));
                                        let moduleRoutes = {}
                                        if (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/LabBilling' || window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === '/DoctorBilling') {
                                            moduleRoutes = {
                                                front_office: "/HospitalBilling",
                                                Laboratory: "/LabBilling",
                                                Radiology: "/RadiologyBilling",
                                                Investigation: `/${GetInvestigationName()}Billing`,
                                                Doctor: '/DoctorBilling'
                                            };
                                        } else {
                                            moduleRoutes = {
                                                front_office: "/HospitalBilling/HospitalBilling",
                                                Laboratory: "/LabBilling/HospitalBilling",
                                                Radiology: "/RadiologyBilling/HospitalBilling",
                                                Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
                                                Doctor: '/DoctorBilling/DoctorBilling'
                                            };
                                        }
                                        setSendPendingOrder({})
                                        getPatientPendingDraftList(null, params?.row?.id);
                                        setOpenPopup(null);
                                        const routePath = moduleRoutes[userData?.module_name];
                                        if (routePath) {
                                            history?.push({ pathname: routePath, state: { pendingDraft: true, pendingOrder: false } });
                                            setTimeout(() => { history?.push({ pathname: routePath, state: {} }) }, 1000);
                                        }
                                    }}
                                >
                                    <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                                </Button>
                                {localGetItem('print_option_for_draft_bills') === 'true' ?<Button
                                    className='Common_Btn_Min_Width'
                                    onClick={() => {
                                        PrintCancelledData(params?.row?.id)
                                    }}
                                >
                                    <Box component={'img'} src={ImagePaths.PrintIcons.default} height={'1.5dvw'} width={'1.8dvw'} />
                                </Button> : null }
                            </Box>
                        )
                    }
                },
            ]
            const order = [
                {
                    field: 'sno', headerName: 'S.No', flex: 0.1,
                    renderCell: (params) => {
                        return (<Box>{params?.row?.sno}</Box>)
                    }
                },
                {
                    field: 'order_details', headerName: 'Order Details', flex: 0.25,
                    renderCell: (params) => {
                        let tempInvoice = params?.row?.order_number
                        return (
                            <Box>
                                {tempInvoice ? tempInvoice?.length > 15 ?
                                    <Tooltip placement='top' title={tempInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + tempInvoice?.slice(-15)}</Typography></Tooltip> :
                                    <Typography fontSize={'0.9rem'} fontWeight={600}>{tempInvoice}</Typography> : '-'}
                                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{convertDateTime(params?.row?.order_date)}</Typography>
                            </Box>
                        )
                    }
                },
                {
                    field: 'orders', headerName: 'No Of Orders', flex: 0.2,
                    renderCell: (params) => {
                        return (
                            <Box>{params?.row?.line_item_count}</Box>
                        )
                    }
                },
                {
                    field: 'doctor_details', headerName: 'Doctor Details', flex: 0.25,
                    renderCell: (params) => {
                        let doctorName = params?.row?.doctor_name
                        let doctorSpec = params?.row?.specialization_name
                        return (
                            <Box>
                                {doctorName ? doctorName?.length > 15 ?
                                    <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                                {doctorSpec ? doctorSpec?.length > 15 ?
                                    <Tooltip placement='top' title={doctorSpec}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec}</Typography> : '-'}
                            </Box>
                        )
                    }
                },
                {
                    field: 'action', headerName: 'Action', flex: 0.2,
                    renderCell: (params) => {
                        return (
                            <Box>
                                <Tooltip placement='top' title={"Move to billing"} arrow>
                                    <Button
                                        disabled={Object.keys(multiPendingData)?.length === 0 ? false : true}
                                        className='Common_Btn_Min_Width'
                                        onClick={() => {
                                            // setPedingOrder(prev => prev.filter((_, index) => (index + 1) !== params?.row?.sno));
                                            let moduleRoutes = {}
                                            if (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/LabBilling' || window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === '/DoctorBilling') {
                                                moduleRoutes = {
                                                    front_office: "/HospitalBilling",
                                                    Laboratory: "/LabBilling",
                                                    Radiology: "/RadiologyBilling",
                                                    Investigation: `/${GetInvestigationName()}Billing`,
                                                    Doctor: '/DoctorBilling'
                                                };
                                            } else {
                                                moduleRoutes = {
                                                    front_office: "/HospitalBilling/HospitalBilling",
                                                    Laboratory: "/LabBilling/HospitalBilling",
                                                    Radiology: "/RadiologyBilling/HospitalBilling",
                                                    Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
                                                    Doctor: '/DoctorBilling/DoctorBilling'
                                                };
                                            }
                                            setSendPendingOrder(params?.row);
                                            setSendDraftData([])
                                            setOpenPopup(null);
                                            setOrderId(null);
                                            setMultiPendingData({});
                                            const routePath = moduleRoutes[userData?.module_name];
                                            if (routePath) {
                                                history?.push({ pathname: routePath, state: { pendingOrder: true, pendingDraft: false } });
                                                setTimeout(() => { history?.push({ pathname: routePath, state: {} }) }, 1000);
                                            }
                                        }}
                                    >
                                        <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                                    </Button>
                                </Tooltip>
                            </Box>
                        )
                    }
                },
            ]
            return (
                <>{openPopup === 'draft' ?
                    <Dialog open={openPopup === 'draft'} fullWidth maxWidth='md'>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Draft Order</Typography>
                                <IconButton
                                    onClick={() => { setOpenPopup(null) }}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Box component={'div'}>
                                    <Typography fontSize={'0.8rem'} color={Colors.grayShade}>Patient Details</Typography>
                                    <Box component={'div'} width={'20dvw'}>
                                        {renderPatientCard(PatientDetails)}
                                    </Box>
                                </Box>
                            </Box>
                            <Box component={'div'} height={'60dvh'} p={'0.5rem'}>
                                <DataGrid
                                    columns={draft}
                                    rows={pendingDraft}
                                    getRowId={(row) => row['sno']}
                                    page={page}
                                    pageSize={pageSize}
                                    onPageChange={(newPage) => { setPage(newPage) }}
                                    onPageSizeChange={(newPageSize) => { setPageSize(newPageSize) }}
                                    rowsPerPageOptions={[10, 20, 30]}
                                    loading={isLoader}
                                    localeText={{
                                        toolbarColumns: "",
                                        toolbarDensity: "",
                                        toolbarExport: "",
                                        toolbarFilters: "",
                                        toolbarExportPrint: ""
                                    }}
                                    components={{
                                        // Toolbar: CommonGridHeader.CommonToolBar,
                                        // Toolbar: this.gridToolBar,
                                        NoRowsOverlay: () => (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                {("No Records Found")}
                                            </Box>
                                        )
                                    }}
                                    headerHeight={40}
                                />
                            </Box>
                        </Box>
                    </Dialog> :
                    <Dialog open={openPopup === 'order'} fullWidth maxWidth='md'>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Pending Order</Typography>
                                <IconButton
                                    onClick={() => {
                                        setOpenPopup(null)
                                        setMultiPendingData({})
                                        setOrderId(null)
                                    }}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                <Box component={'div'}>
                                    <Typography fontSize={'0.8rem'} color={Colors.grayShade}>Patient Details</Typography>
                                    <Box component={'div'} width={'20dvw'}>
                                        {renderPatientCard(PatientDetails)}
                                    </Box>
                                </Box>
                                <Box component={'div'}>
                                    {Object?.keys(multiPendingData)?.length === 0 ? null :
                                        <Button
                                            sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                            variant='contained'
                                            onClick={() => {
                                                let moduleRoutes = {}
                                                if (window.location.pathname === '/HospitalBilling' || window.location.pathname === '/LabBilling' || window.location.pathname === `/${GetInvestigationName()}Billing` || window.location.pathname === '/DoctorBilling') {
                                                    moduleRoutes = {
                                                        front_office: "/HospitalBilling",
                                                        Laboratory: "/LabBilling",
                                                        Radiology: "/RadiologyBilling",
                                                        Investigation: `/${GetInvestigationName()}Billing`,
                                                        Doctor:'/DoctorBilling'
                                                    };
                                                } else {
                                                    moduleRoutes = {
                                                        front_office: "/HospitalBilling/HospitalBilling",
                                                        Laboratory: "/LabBilling/HospitalBilling",
                                                        Radiology: "/RadiologyBilling/HospitalBilling",
                                                        Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
                                                        Doctor: '/DoctorBilling/DoctorBilling'
                                                    };
                                                }
                                                const routePath = moduleRoutes[userData?.module_name];
                                                if (routePath) {
                                                    history?.push({ pathname: routePath, state: { pendingOrder: true } });
                                                    setSendPendingOrder(multiPendingData);
                                                    setOpenPopup(null);
                                                    setTimeout(() => {
                                                        setMultiPendingData({});
                                                        setOrderId(null);
                                                    }, 100);
                                                    setTimeout(() => history?.push({ pathname: routePath, state: {} }), 1500);
                                                }
                                            }}
                                        >Move To Billing</Button>}
                                </Box>
                            </Box>
                            <Box component={'div'} height={'60dvh'} p={'0.5rem'}>
                                <DataGrid
                                    checkboxSelection
                                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                                    columns={order}
                                    rows={pendingOrder}
                                    getRowId={(row) => row['sno']}
                                    page={page}
                                    pageSize={pageSize}
                                    onPageChange={(newPage) => { setPage(newPage) }}
                                    onPageSizeChange={(newPageSize) => { setPageSize(newPageSize) }}
                                    rowsPerPageOptions={[10, 20, 30]}
                                    loading={isLoader}
                                    localeText={{
                                        toolbarColumns: "",
                                        toolbarDensity: "",
                                        toolbarExport: "",
                                        toolbarFilters: "",
                                        toolbarExportPrint: ""
                                    }}
                                    components={{
                                        // Toolbar: CommonGridHeader.CommonToolBar,
                                        // Toolbar: this.gridToolBar,
                                        NoRowsOverlay: () => (
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                {("No Records Found")}
                                            </Box>
                                        )
                                    }}
                                    headerHeight={40}
                                />
                            </Box>
                        </Box>
                    </Dialog>
                }</>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const clearAllData = () => {
        try {
            setSendDraftData([])
            setSendPendingOrder({})
            setSendBillingList([])
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const clearPatientData = (message) => {
        try {
            if (message) {
                if (getCachevalue('FromCreate') !== 'true') {
                    setPatientDetails({})
                    setUhidOrPhNumber('')
                    setIPorIPNumber('')
                    setSelectedAppointment(null)
                    props.getbillingCount(true)
                    if (userData?.module_name === 'front_office') {
                        props.VisitDateBalAmount({})
                    }
                    getCollectionDetails()
                }
                if (PatientDetails?.patient_id && PatientDetails?.appointment_id) {
                    getPendingOrderList(PatientDetails?.patient_id, '', PatientDetails?.appointment_id)
                    getPatientPendingDraftList(PatientDetails?.patient_id, '', PatientDetails?.appointment_id)
                }

            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const insuranceName = PatientDetails?.insurance_company_name || PatientDetails?.insurance_name || "";
    return (
        <Box className="emed_multibill_container">
            <Box component={'div'}>
                <Box component={'div'} height={'10dvh'} p={'0.5rem'} display={'flex'}>
                    {/* {newAmountCard('Total Patient', cardState.totalPatients, true, 'white', false, 'white', 'tlt_pat', '8dvw', '', '8dvh')} */}
                    {newAmountCard('Total Bills', cardState.totalBills, true, 'white', false, 'white', 'tlt_bills', '8dvw', '0.5rem', '8dvh')}
                    {newAmountCard('Bill Amount', cardState.totalBillingAmount, false, 'white', false, 'white', 'tlt_bill_amt', '8dvw', '0.5rem', '8dvh')}
                    {newAmountCard('Credit Amount', cardState.totalCreditAmount, false, 'white', false, 'white', 'tlt_crdt', '8dvw', '0.5rem', '8dvh')}
                    {newAmountCard('Cancelled Bills', cardState.totalCancelAmount, true, 'white', false, 'white', 'tlt_rfd', '8dvw', '0.5rem', '8dvh')}
                    {newAmountCard('Refund Amount', cardState.totalRefundAmount, false, 'white', false, 'white', 'tlt_cal', '8dvw', '0.5rem', '8dvh')}
                    <Button className='Common_Btn_Min_Width eMed_Recpt_header_amt_card'
                        onClick={() => setCardState((prev) => ({ ...prev, openReceipt: !cardState.openReceipt }))}
                    >{newAmountCard('Receipt Amount', cardState.totalReceiptAmount, false, cardState.openReceipt ? Colors.Primary : 'white', true, cardState.openReceipt ? 'white' : Colors.Primary, 'tlt_rpt', '8dvw', '0.5rem', '8dvh')}</Button>
                    <Box component={'div'} display={'flex'} width={'33dvw'} overflow={'auto'}>
                        {cardState.openReceipt ?
                            <Box sx={{ display: 'flex', flexDirection: "row", mt: '0.2rem' }}>
                                <Grow in={cardState.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                    {...(cardState.openReceipt ? { timeout: 500 } : {})}>{newAmountCard('Cash', cardState.totalCashAmount, false, 'white', false, 'white', 'tlt_cash', '8dvw', '0.5rem', '6dvh')}</Grow>
                                <Grow in={cardState.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                    {...(cardState.openReceipt ? { timeout: 1000 } : {})}>{newAmountCard('Card', cardState.totalCardAmount, false, 'white', false, 'white', 'tlt_card', '8dvw', '0.5rem', '6dvh')}</Grow>
                                <Grow in={cardState.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                    {...(cardState.openReceipt ? { timeout: 1500 } : {})}>{newAmountCard('UPI', cardState.totalUpiAmount, false, 'white', false, 'white', 'tlt_upi', '8dvw', '0.5rem', '6dvh')}</Grow>
                                <Grow in={cardState.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                    {...(cardState.openReceipt ? { timeout: 2000 } : {})}>{newAmountCard('Bank', cardState.totalBanKAmount, false, 'white', false, 'white', 'tlt_bank', '8dvw', '0.5rem', '6dvh')}</Grow>
                                <Grow in={cardState.openReceipt} style={{ transformOrigin: '0 0 0' }}
                                    {...(cardState.openReceipt ? { timeout: 2500 } : {})}>{newAmountCard('Cheque', cardState.totalChequeAmount, false, 'white', false, 'white', 'tlt_cheque', '8dvw', '0.5rem', '6dvh')}</Grow>
                            </Box> : null}
                    </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start' }}>
                    <Box sx={{ backgroundColor: "white", display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', marginLeft: '0.5vw', padding: "0.5vw", boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                        {getCachevalue('FromOtherScreen') === 'true' ?
                            <Button
                                variant='contained'
                                sx={{ textTransform: 'capitalize', width: '12.9vw', marginRight: "0.5vw" }}
                                onClick={() => {
                                    clearCachevalue('isForCancelBill')
                                    clearCachevalue('BillType')
                                    clearCachevalue('FromOtherScreen')
                                    clearCachevalue('FromCreate')
                                    clearCachevalue('currPatientData')
                                    let path = getCachevalue('path')
                                    // if (userData?.module_name === 'Laboratory') {
                                    //     history.push({ pathname: "/MainHome", state: { selectedScreen: "Order", selectedTabID: 5 } })
                                    // } else {
                                    history?.push({ pathname: path, state: {} })
                                    clearCachevalue('path')
                                    // }
                                }}
                            >Back</Button> : <TextField
                                size='small'
                                label={"UHID / Ph No"}
                                sx={{ width: '12vw', marginRight: "0.5vw" }}
                                id="icd-cde"
                                placeholder='Search by UHID / Ph No'
                                inputProps={{ maxLength: 20, emed_tid: "UhidorphNumber" }}
                                variant="outlined"
                                value={UhidOrPhNumber}
                                onChange={(event) => setUhidOrPhNumber(event.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && e.target.value !== '' && e.target.value?.length > 4) {
                                        getPatientDataSearch(UhidOrPhNumber)
                                        setHasDraftOrder('both')
                                    }
                                }}
                            />}
                        <Autocomplete
                            freeSolo
                            size={'small'}
                            options={appointmentList || []}
                            disabled={getCachevalue('BillType') === 'Cancel' || getCachevalue('FromOtherScreen') === 'true' || hasDraftOrder === 'draft' || hasDraftOrder === 'order'}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : (option?.op_number ? `...${option?.op_number?.slice(10)}` : "")}
                            value={selectedAppointment || ""}
                            onChange={(event, newValue) => {
                                setSelectedAppointment(newValue)
                                getIndividualBillDetails(null, false, true, newValue?.op_number)
                                getPendingOrderList(newValue?.patient_id, '', newValue?.appointment_id)
                                getPatientPendingDraftList(newValue?.patient_id, '', newValue?.appointment_id)
                                getPatientDetails(newValue?.appointment_id, true)
                            }}
                            clearIcon={false}
                            renderInput={(params) => <TextField {...params} label={'OP Number'} sx={{ width: '12.9vw' }} disabled={getCachevalue('BillType') === 'Cancel'}
                            />}
                        />
                    </Box>
                    {Object.keys(PatientDetails)?.length === 0 ? null :
                        <><Box>{renderPatientCard(PatientDetails, 'consultant')}</Box>
                            <Box>{renderPatientCard(PatientDetails)}</Box>
                            <Box sx={{ backgroundColor: "white", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '0.5vw', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: "18vw", padding: "0.1vw" }}>
                                <Box sx={{ width: "50%" }}>
                                    <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
                                        Insurance Name
                                    </div>
                                    <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
                                        {insuranceName ? insuranceName?.length > 20 ?
                                            <Tooltip placement='top' title={insuranceName}><Typography sx={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>{insuranceName?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                            <Typography sx={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>{insuranceName}</Typography> : '-'}
                                    </div>
                                    <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
                                        Policy Number
                                    </div>
                                    <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
                                        {PatientDetails?.policy_number || PatientDetails?.policy_no || '-'}
                                    </div>
                                </Box>
                                <Box sx={{ width: "50%" }}>
                                    <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
                                        TPA
                                    </div>
                                    <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
                                        -
                                    </div>
                                    <div style={{ fontSize: '0.7vw', lineHeight: '0.85vw' }}>
                                        Corporate
                                    </div>
                                    <div style={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>
                                        {PatientDetails?.company_name ? PatientDetails?.company_name?.length > 20 ?
                                            <Tooltip placement='top' title={PatientDetails?.company_name}><Typography sx={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>{PatientDetails?.company_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                                            <Typography sx={{ fontSize: '0.65vw', color: "black", lineHeight: '0.85vw', fontWeight: "600" }}>{PatientDetails?.company_name}</Typography> : '-'}
                                    </div>
                                </Box>
                            </Box>
                            <Box component={'div'} ml={'0.5rem'}>
                                <Box component={'div'} visibility={(hasDraftOrder === 'order' || hasDraftOrder === 'both') ? 'visible' : 'hidden'}>
                                    <Button
                                        color='warning'
                                        variant='outlined'
                                        disabled={getCachevalue('BillType') === 'Cancel'}
                                        sx={{ fontSize: '0.75rem', height: '3dvh', textTransform: 'capitalize' }}
                                        startIcon={<GppMaybeIcon color='warning' />}
                                        onClick={() => {
                                            setOpenPopup('order')
                                            setMultiPendingData({})
                                        }}
                                    >{`Pending Order (${pendingOrder?.length})`}</Button>
                                </Box>
                                <Box component={'div'} mt={'0.3rem'} visibility={(hasDraftOrder === 'draft' || hasDraftOrder === 'both' || (getCachevalue('FromOrderCreate') === 'true' && hasDraftOrder === null)) ? 'visible' : 'hidden'}>
                                    <Button
                                        color='warning'
                                        variant='outlined'
                                        disabled={getCachevalue('BillType') === 'Cancel'}
                                        sx={{ fontSize: '0.75rem', height: '3dvh', textTransform: 'capitalize' }}
                                        startIcon={<GppMaybeIcon color='warning' />}
                                        onClick={() => { setOpenPopup('draft') }}
                                    >{`Pending Draft (${pendingDraft?.length})`}</Button>
                                </Box>
                            </Box>
                        </>}
                </Box>
                <Box component={'div'} height={'61dvh'}>
                    <Billling
                        triggerNotifyCount = {props.triggerNotifyCount}
                        clearPatientData={clearPatientData}
                        patientData={PatientDetails}
                        draftData={sendDraftData}
                        clearAllData={clearAllData}
                        orderData={sendPendingOrder ?? {}}
                        billingData={sendBillingList ?? []}
                        triggerPatientData = {triggerPatientData}
                        fromHospitalBilling = {true}
                    />
                </Box>
            </Box>
            {renderPendingDraftPopup()}
            {PatientSelectionPopup()}
            {isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={isErrorMsgText}
                    msgPop={() => setIsErrorMsg(false)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={() => setSuccessMsg(false)}
                />
                : null}
            <Loader loaderOpen={isLoader} />
        </Box>
    );
};

export default HospitalBilling;